import zip from 'assets/icons/zip.png'
import xls from 'assets/icons/xls.png'
import img from 'assets/icons/img.png'
import pdf from 'assets/icons/pdf.png'

const icons = {
  zip: zip,
  xls: xls,
  xlsx: xls,
  csv: xls,
  png: img,
  jpg: img,
  jpeg: img,
  gif: img,
  pdf: pdf,
}

export default icons
